import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getAsset = (state) => get(state, 'assets.form.asset', {});
export const getIsLoadingForm = (state) => get(state, 'assets.form.isLoading', false);
export const getIsLoadingList = (state) => get(state, 'assets.list.isLoading', false);
export const getPagination = (state) => get(state, 'assets.list.pagination', {});
export const getFilters = (state) => get(state, 'assets.list.filters', {});

export const getNeedFetch = (state) => get(state, 'assets.list.needFetch', false);

export const getUploadFiles = (state) => get(state, 'assets.form.uploadFiles', {});
export const getUploadFilesIds = (state) => get(state, 'assets.form.uploadFilesIds', []);

export const getAssetIds = (state) => get(state, 'assets.list.result.assets', []);
export const getAssets = (state) => get(state, 'assets.list.entities.assets', {});

export const getAssetsIsSaving = (state) => get(state, 'assets.form.isSaving', false);

export const getIsFetching = (state) => get(state, 'assets.form.isFetching', false);

export const getEnableModalIsOpened = (state) =>
  get(state, 'assets.actions.enableModalIsOpened', false);

export const getSelectedAsset = (state) => get(state, 'assets.actions.asset', null);

export const getHistoricsPagination = (state) => get(state, 'assets.historics.pagination', {});
export const getHistoricsFilters = (state) => get(state, 'assets.historics.filters', {});
export const getHistoricsNeedFetch = (state) => get(state, 'assets.historics.needFetch', false);
export const getHistoricsIsLoading = (state) => get(state, 'assets.historics.isLoading', false);
export const getHistoricsIsSaving = (state) => get(state, 'assets.historics.isSaving', false);
export const getHistoricsIds = (state) => get(state, 'assets.historics.result.historics', []);
export const getHistorics = (state) => get(state, 'assets.historics.entities.historics', {});

export const getVisibleAssets = createSelector([getAssetIds, getAssets], (ids, assets) =>
  ids.map((id) => assets[id])
);

export const getVisibleUploadFiles = createSelector(
  [getUploadFilesIds, getUploadFiles],
  (ids, files) => ids.map((id) => files[id])
);

export const getVisibleHistorics = createSelector(
  [getHistoricsIds, getHistorics],
  (ids, historics) => ids.map((id) => historics[id])
);



// WEBPACK FOOTER //
// src/selectors/assets.js